const config = {
  fieldControl: false,
  rowKey: 'id',
  columns: [
    {
      title: '线索ID',
      dataIndex: 'clueId',
      width: 200,
      fixed: 'left',
      render: 'clueIdRender',
    },
    {
      title: '商机ID',
      dataIndex: 'id',
      width: 200,
      fixed: 'left',
      render: 'trackIdRender',
    },
    {
      title: '客户姓名',
      dataIndex: 'name',
      width: 150,
    },
    {
      title: '客户电话',
      dataIndex: 'phone',
      width: 140,
      render: 'checkPhone',
    },

    {
      title: '楼盘名称',
      dataIndex: 'buildingName',
      width: 160,
      ellipsis: true,
    },
    {
      title: '客户来源',
      dataIndex: 'channelName',
      width: 260,
      ellipsis: true,
    },
    {
      title: '需求标签',
      dataIndex: 'bizTypeName',
      width: 120,
    },
    {
      title: '所属组织',
      dataIndex: 'orgName',
      width: 150,
    },
    {
      title: '营销员',
      dataIndex: 'sales',
      width: 100,
    },
    {
      title: '设计师',
      dataIndex: 'designer',
      width: 100,
    },
    {
      title: '签单金额（元）',
      dataIndex: 'signAmount',
      width: 160,
    },
    {
      title: '签单时间',
      dataIndex: 'signTime',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '首访时间',
      dataIndex: 'firstDate',
      itemType: 'date',
      width: 180,
    },
    {
      title: '最后跟进时间',
      dataIndex: 'lastFollowTime',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '状态',
      dataIndex: 'statusName',
      width: 100,
      render: 'stateRender',
      fixed: 'right',
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 180,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'nameLike',
      label: '客户姓名',
    },
    {
      name: 'phone',
      label: '客户电话',
      itemType: 'number',
    },
    {
      name: 'clueId',
      label: '线索ID',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
    },
    {
      name: 'id',
      label: '商机ID',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
    },

    {
      name: 'bizType',
      label: '需求标签',
      span: 120,
      itemType: 'select',
      key: 'key',
      labelKey: 'description',
      data: 'typeListArr',
    },
    {
      name: 'orgId',
      label: '公司',
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'companyList',
      events: ['onChange:onCompanyChange'],
    },
    {
      name: 'deptId',
      label: '部门',
      span: 120,
      itemType: 'tree',
      key: 'id',
      labelKey: 'label',
      data: 'designDept',
      notFoundContent: '请选择公司或无匹配数据',
      events: ['filterOption:filterOption', 'onChange:onDesignDeptChange'],
    },
    {
      name: 'ucenterUserId',
      label: '设计师',
      span: 120,
      itemType: 'select',
      key: 'ucenterUserId',
      labelKey: 'userName',
      data: 'designer',
      notFoundContent: '请选择部门或无匹配数据',
      events: ['filterOption:filterOption'],
    },
    {
      name: 'status',
      label: '状态',
      itemType: 'select',
      key: 'key',
      labelKey: 'description',
      data: 'clueStatusEnum',
    },

    {
      name: 'buildingId',
      label: '楼盘名称',
      span: 120,
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'buildingId',
      notFoundContent: '请选择公司或无匹配数据',
    },

    {
      name: 'channelIds',
      label: '客户来源',
      itemType: 'tree',
      data: 'channels',
      labelKey: 'label',
      key: 'id',
      treeCheckable: true,
      allowClear: true,
      showSearch: true,
    },
    // {
    //   name: 'plan',
    //   label: '最小建筑面积',
    // },
    // {
    //   name: 'plan',
    //   label: '最大建筑面积',
    // },
    // {
    //   name: 'plan',
    //   label: '最后跟进',
    // },
    {
      name: 'firstDate',
      label: '首访日期',
      placeholder: ['首访日期起', '止'],
      span: 140,
      itemType: 'autoDate',
      showTime: 'true',
    },
  ],
  footer: [
    // {
    //   label: '导出',
    //   auth: 'warehousingClueExportBtn',
    //   type: 'primary',
    //   events: ['onClick:onExport'],
    // },
    // {
    //   label: '导出（不含撞单）',
    //   auth: 'collisionClueExportBtn',
    //   type: 'primary',
    //   events: ['onClick:onCollisionExport'],
    // },
  ],
  batchActions: [
    {
      label :'批量改派',
      type: 'primary',
      auth: 'batchReassignmentDesigner',
      events: ['onClick:onBatchChange'],
    },
  ],
}

export default config
